import { ErrorLink, onError } from '@apollo/client/link/error';

export const createGlobalErrorHandlerMiddleware = (globalErrorHandler: ErrorLink.ErrorHandler) => {
  return onError(globalErrorHandler);
};
